import { ImageView } from '@play-co/timestep-core/ui';
import DecorationView, {
  DecorationEditOpts,
  DecorationSlotOpts,
} from './DecorationView';
import uiConfig from 'src/lib/ui/config';
import { DecorationRoomID } from 'src/replicant/decoration/decoration.ruleset';

// Available slots ids
type SlotsID = 1 | 2 | 3 | 4 | 5;

// Room ID
const ROOM: DecorationRoomID = 'toilet';

/**
 * This view keep all view setup and defaults for this type room
 */
export default class ToiletRoomDecorationView extends DecorationView {
  // Config for slots placeholders
  private config: Map<SlotsID, DecorationSlotOpts> = new Map([
    // Wallpaper
    [1, { width: 719, height: 1276, x: -1, y: 0, zIndex: 0 }],
    // Floor
    [2, { width: 730, height: 460, x: -6, y: 589, zIndex: 3 }],
    // Arch
    [3, { width: 681, height: 601, x: 16, y: 269, zIndex: 6 }],
    // Toilet
    [4, { width: 401, height: 561, x: 172, y: 446, zIndex: 4 }],
    // Toilet ornament
    [5, { width: 681, height: 201, x: 25, y: 809, zIndex: 5 }],
  ]);

  // Config for slots edit buttons placeholders
  private edit: Map<SlotsID, DecorationEditOpts> = new Map([
    // Wallpaper
    [1, { x: 25, y: 230 }],
    // Floor
    [2, { x: 86, y: 703 }],
    // Arch
    [3, { x: 534, y: 431 }],
    // Toilet
    [4, { x: 291, y: 581 }],
    // Toilet ornament
    [5, { x: 32, y: 919 }],
  ]);

  // Default slots content
  private slots: Map<SlotsID, string> = new Map([
    [1, '04_toilet_room/default/01_wallpaper.png'],
    [2, '04_toilet_room/default/02_floor.png'],
    [3, '04_toilet_room/default/03_arch.png'],
    [4, '04_toilet_room/default/04_toilet.png'],
    [5, '04_toilet_room/default/05_toilet_ornament.png'],
  ]);

  // Header element
  private header = {
    image: 'assets/ui/decoration/frames/toilet_room_header.png',
    x: -7,
    y: -41,
    width: 729,
    height: 223,
    zIndex: 10,
  };

  // Footer scene
  private footer = {
    image: 'assets/ui/decoration/background/toilet_room_base.png',
    width: 723,
    height: 618,
    x: -11,
    y: 654,
    zIndex: 2,
  };

  /**
   * Build room view and setup abstraction layer
   */
  constructor(opts: { autoDecorationUpdate: boolean }) {
    super(ROOM, {
      width: uiConfig.width,
      height: uiConfig.height,
    });

    // Create slot views
    for (const [slot, defaultImage] of this.slots) {
      this.createSlot(
        slot,
        defaultImage,
        this.config.get(slot)!,
        this.edit.get(slot)!,
      );
    }

    // Add header
    new ImageView({
      tag: 'header',
      superview: this,
      ...this.header,
    });

    // Add footer
    new ImageView({
      tag: 'footer',
      superview: this,
      ...this.footer,
    });

    // Connect listeners
    if (opts.autoDecorationUpdate) {
      this.listenSlotChangeEvent();
    }
  }
}
